import Cookies from 'js-cookie';
import api from 'api';

const KAVAK_MONTHLY_REPORT_FEATURE = 'gerar-relatorio-mensal-backoffice';

export const generateKavakMonthlyReport = async (billetGeneration = false) => {
  const token = Cookies.get('splitrisk-authtoken');

  return api({
    method: 'POST',
    url: `/export-kavak-installments-policies`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      feature: KAVAK_MONTHLY_REPORT_FEATURE,
    },
    params: {
      billetGeneration,
      force: 'true',
    },
    json: true,
  });
};
